// Application dependencies

import { TimeZonesTable } from "@/interfaces/authorisation/timeZones.Interfaces";

// State Enums -----------------------------------------------------------------------------------------------------------------------------

export enum StateFields {
  Code = "code",
  Country = "country",
  CountryId = "country_id",
  CountryName = "country_name",
  CreatedAt = "created_at",
  Id = "id",
  NameLong = "name_long",
  NameShort = "name_short",
  TimeZone = "time_zone",
  TimeZoneDescription = "time_zone_description",
  TimeZoneId = "time_zone_id",
  UpdatedAt = "updated_at",
  Zone = "zone",
}

// State Interfaces ------------------------------------------------------------------------------------------------------------------------

export interface State {
  [StateFields.Code]: string;
  [StateFields.CountryId]: number;
  [StateFields.CreatedAt]: string | null;
  [StateFields.Id]: number;
  [StateFields.NameLong]: string;
  [StateFields.NameShort]: string;
  [StateFields.TimeZoneId]: number;
  [StateFields.UpdatedAt]: string | null;
}

export interface StateCrud {
  [StateFields.Code]: string;
  [StateFields.CountryId]: number;
  [StateFields.Id]: number | null;
  [StateFields.NameLong]: string;
  [StateFields.NameShort]: string;
  [StateFields.TimeZoneId]: number;
}

export interface StateDetail {
  [StateFields.Code]: string;
  [StateFields.Country]: string;
  [StateFields.CreatedAt]: string | null;
  [StateFields.Id]: number;
  [StateFields.NameLong]: string;
  [StateFields.NameShort]: string;
  [StateFields.UpdatedAt]: string | null;
  [StateFields.TimeZone]: TimeZonesTable | null;
}
